/* Nurturi — pdp.js   (loaded only on product pages, deferred)
   Gallery + swipe, variant selection, add-on line item, animated accordions,
   sticky add-to-cart. Depends on window.Nurturi (global.js) for cart + money. */
(function () {
  'use strict';

  function money(cents) {
    return (window.Nurturi && window.Nurturi.formatMoney) ? window.Nurturi.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
  }

  function initSection(root) {
    if (!root || root._ntInit) return;
    root._ntInit = true;

    /* ---------------- Gallery ---------------- */
    // Slides/dots are index-parallel, so one absolute index addresses both. `visible`
    // holds the absolute indices still in play after colourway filtering; `index` is a
    // position *within* visible, which is also the slide's laid-out position once the
    // filtered-out slides are display:none.
    var DOT_WINDOW = 7; // dots rendered before the rail starts sliding

    root.querySelectorAll('[data-gallery]').forEach(function (g) {
      var track = g.querySelector('[data-gallery-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var dots = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-go]'));
      var dotsView = g.querySelector('[data-gallery-dots]');
      var thumbsView = g.querySelector('.gallery__thumbs');
      var badge = g.querySelector('.gallery__badge');
      var feats = g.querySelector('.gallery__feats');
      var groups = slides.map(function (s) { return (s.getAttribute('data-media-group') || '').toLowerCase().trim(); });
      var hasGroups = groups.some(Boolean);
      var visible = slides.map(function (_, i) { return i; });
      var index = 0;
      var heroId = null; // media id of the colourway's assigned photo, if it has one

      // Badge + hero feature boxes are authored on slide 0 but belong to the colourway's
      // hero shot: the selected variant's assigned image when there is one, otherwise the
      // slide leading the filtered set. Move the nodes rather than rendering a copy per
      // colour, so only one slide ever carries them.
      function heroSlide() {
        if (heroId != null) {
          for (var i = 0; i < visible.length; i++) {
            var s = slides[visible[i]];
            if (s.getAttribute('data-media-id') == heroId) return s;
          }
        }
        return slides[visible[0]];
      }
      function moveOverlays() {
        var host = heroSlide();
        if (!host) return;
        if (badge && badge.parentNode !== host) host.insertBefore(badge, host.firstChild);
        if (feats && feats.parentNode !== host) host.appendChild(feats);
      }

      // Sliding window: keep the active dot near the middle, taper the window's edge
      // dots to signal "more this way", and hide the rest. The taper only applies on a
      // side that actually continues — when the window butts against the true start or
      // end of the set, that side stays full size so the ends read as ends.
      function applyDotWindow(live) {
        if (!dotsView) return;
        var n = live.length, capped = n > DOT_WINDOW;
        dotsView.classList.toggle('gallery__dots--capped', capped);
        var start = capped ? Math.min(Math.max(index - (DOT_WINDOW >> 1), 0), n - DOT_WINDOW) : 0;
        var end = start + DOT_WINDOW - 1;
        live.forEach(function (d, i) {
          var inWin = !capped || (i >= start && i <= end);
          d.hidden = !inWin;
          d.classList.remove('is-sm', 'is-xs');
          if (!capped || !inWin) return;
          var edge = DOT_WINDOW; // distance to the nearest *continuing* window edge
          if (start > 0) edge = Math.min(edge, i - start);
          if (end < n - 1) edge = Math.min(edge, end - i);
          if (edge === 0) d.classList.add('is-xs');
          else if (edge === 1) d.classList.add('is-sm');
        });
      }

      // Thumbs already scroll; just keep the active one in view after a filter change.
      function revealThumb(t) {
        if (!thumbsView || !t) return;
        var l = t.offsetLeft, r = l + t.offsetWidth, s = thumbsView.scrollLeft, w = thumbsView.clientWidth;
        if (l < s) thumbsView.scrollLeft = l - 8;
        else if (r > s + w) thumbsView.scrollLeft = r - w + 8;
      }

      // Swipes and arrows slide; colourway jumps cut. Sliding from Blush (slide 1) to
      // White (slide 17) would smear 16 unrelated photos past the viewer in 350ms, so
      // variant-driven moves commit the transform with transitions off. Forcing a reflow
      // while .is-instant is applied lands the new position before transitions come back.
      function setTransform(instant) {
        if (instant) track.classList.add('is-instant');
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        if (instant) {
          void track.offsetWidth;
          track.classList.remove('is-instant');
        }
      }

      function render(instant) {
        setTransform(instant);
        var live = visible.map(function (ai) { return dots[ai]; }).filter(Boolean);
        live.forEach(function (d, i) { d.setAttribute('aria-current', i === index ? 'true' : 'false'); });
        applyDotWindow(live);
        moveOverlays();
        revealThumb(live[index]);
      }
      function go(i, instant) { var c = visible.length; if (!c) return; index = (i % c + c) % c; render(instant); }
      g._go = go;

      // Show only the chosen colourway's media (plus ungrouped/shared media). Bails out
      // when no media carries a group, or when nothing matches the selection — a missing
      // or misspelled alt prefix must degrade to "show everything", never to an empty frame.
      g._filter = function (color) {
        var key = (color || '').toLowerCase().trim();
        var on = hasGroups && !!key && groups.indexOf(key) !== -1;
        var keptMedia = visible.length ? slides[visible[index]].getAttribute('data-media-id') : null;
        visible = [];
        slides.forEach(function (s, i) {
          var show = !on || groups[i] === '' || groups[i] === key;
          s.classList.toggle('is-off', !show);
          if (dots[i]) dots[i].classList.toggle('is-off', !show);
          if (show) visible.push(i);
        });
        // Hold position on the same photo if it survived the filter, else reset to the top.
        var kept = keptMedia == null ? -1 : visible.findIndex(function (ai) {
          return slides[ai].getAttribute('data-media-id') === keptMedia;
        });
        index = kept > -1 ? kept : 0;
        render(true);
      };

      // Promote one slide's image out of lazy loading. Every slide but the first is lazy,
      // so a colourway's photo is typically still unfetched when it's selected.
      function warmSlide(slide) {
        var img = slide && slide.querySelector('img');
        if (!img || img._warmed) return img;
        img._warmed = true;
        img.setAttribute('loading', 'eager');
        return img;
      }
      g._warm = function (mediaId) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') == mediaId) { warmSlide(slides[i]); return; }
        }
      };

      // One atomic move for a variant change: pick the hero, jump to it, relocate the
      // overlays. If its image can't paint yet the whole move waits, so the old photo stays
      // put instead of cutting to an empty frame — that wait IS the flash fix. Capped so a
      // slow image can never leave the swatch feeling unresponsive.
      g._showVariant = function (mediaId) {
        var target = -1;
        for (var i = 0; i < visible.length; i++) {
          if (slides[visible[i]].getAttribute('data-media-id') == mediaId) { target = i; break; }
        }
        function commit() {
          heroId = (mediaId === undefined || mediaId === '') ? null : mediaId;
          if (target > -1) go(target, true); else render(true);
        }
        if (target < 0) { commit(); return; }

        var img = warmSlide(slides[visible[target]]);
        if (!img || (img.complete && img.naturalWidth)) { commit(); return; }

        var done = false;
        function fire() { if (!done) { done = true; commit(); } }
        if (img.decode) img.decode().then(fire).catch(fire);
        else img.addEventListener('load', fire, { once: true });
        setTimeout(fire, 220);
      };

      var prev = g.querySelector('[data-gallery-prev]');
      var next = g.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      dots.forEach(function (d, ai) {
        d.addEventListener('click', function () {
          var p = visible.indexOf(ai);
          if (p > -1) go(p);
        });
      });

      // swipe (horizontal lock, 40px threshold)
      var x0 = null, y0 = null, locked = null;
      track.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; locked = null; }, { passive: true });
      track.addEventListener('touchmove', function (e) {
        if (x0 === null) return;
        var t = e.touches[0];
        if (locked === null) locked = Math.abs(t.clientX - x0) > Math.abs(t.clientY - y0) ? 'x' : 'y';
        if (locked === 'x') e.preventDefault();
      }, { passive: false });
      track.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (locked === 'x' && Math.abs(dx) > 40) { go(dx < 0 ? index + 1 : index - 1); }
        x0 = y0 = locked = null;
      }, { passive: true });

      render();
    });

    // Cut to the variant's photo and move the badge + hero feature boxes onto it, so each
    // colourway gets the overlays on its own assigned image. Null hands them back to the
    // first visible slide (variant with no assigned media, or no colour option at all).
    function galleriesShowVariant(mediaId) {
      root.querySelectorAll('[data-gallery]').forEach(function (g) { if (g._showVariant) g._showVariant(mediaId); });
    }

    // Variant photos sit deep in the carousel and load lazily, so selecting a colourway
    // would otherwise cut to an unfetched image. Warm just those few once the page is idle
    // — the other ~20 shots stay lazy so first paint is unaffected.
    function warmVariantHeroes() {
      var ids = {};
      variants.forEach(function (v) { if (v.media_id) ids[v.media_id] = true; });
      root.querySelectorAll('[data-gallery]').forEach(function (g) {
        if (g._warm) Object.keys(ids).forEach(g._warm);
      });
    }

    // Colour swatch → gallery filter. Driven off `selected` rather than the resolved
    // variant so the gallery still follows the swatch when the size/colour combo is
    // sold out and no variant resolves.
    function galleriesApplyColor(opts) {
      root.querySelectorAll('[data-gallery]').forEach(function (g) {
        var pos = parseInt(g.getAttribute('data-color-pos'), 10) || 0;
        if (pos && g._filter) g._filter(opts[pos - 1] || '');
      });
    }

    /* ---------------- Variants ---------------- */
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-product-variants]').textContent); } catch (e) {}
    var financeCount = parseInt(root.getAttribute('data-finance-count'), 10) || 4;

    var current = variants.filter(function (v) { return String(v.id) === root.getAttribute('data-current-variant'); })[0] || variants[0];
    var selected = current ? current.options.slice() : [];

    function show(el, on) { if (el) el.toggleAttribute('hidden', !on); }

    function applyVariant(v) {
      current = v;
      var has = v && v.compare_at_price > v.price;
      var pct = has ? Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) : 0;

      root.querySelectorAll('[data-price-now]').forEach(function (e) { e.textContent = v ? money(v.price) : '—'; });
      root.querySelectorAll('[data-cta-now]').forEach(function (e) { e.textContent = v ? money(v.price) : ''; });
      root.querySelectorAll('[data-price-was]').forEach(function (e) { show(e, has); if (has) e.textContent = money(v.compare_at_price); });
      root.querySelectorAll('[data-cta-was]').forEach(function (e) { show(e, has); if (has) e.textContent = money(v.compare_at_price); });
      root.querySelectorAll('[data-discount]').forEach(function (e) { show(e, has); if (has) e.textContent = pct + '% OFF'; });
      root.querySelectorAll('[data-finance]').forEach(function (e) { if (v) e.textContent = money(Math.round(v.price / financeCount)); });
      root.querySelectorAll('[data-sticky-variant]').forEach(function (e) { if (v) e.textContent = v.title; });

      var available = v && v.available;
      root.querySelectorAll('[data-atc]').forEach(function (btn) {
        btn.disabled = !available;
        var label = btn.querySelector('[data-atc-text]');
        if (label) label.textContent = !v ? (window.Nurturi ? 'Unavailable' : 'Unavailable') : (available ? 'Add to Cart' : 'Sold out');
      });

      galleriesApplyColor(selected);
      galleriesShowVariant(v ? v.media_id : null);

      if (v) {
        if (history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u);
        }
        root.setAttribute('data-current-variant', v.id);
      }
    }

    function resolveVariant() {
      var match = variants.filter(function (v) {
        return v.options.length === selected.length && v.options.every(function (o, i) { return o === selected[i]; });
      })[0];
      applyVariant(match || null);
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-option-value]');
      if (!opt) return;
      var pos = parseInt(opt.getAttribute('data-option-value'), 10);
      var val = opt.getAttribute('data-value');
      selected[pos - 1] = val;
      // sync every instance of this option (desktop + mobile)
      root.querySelectorAll('[data-option-value="' + pos + '"]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-value') === val ? 'true' : 'false');
      });
      root.querySelectorAll('[data-option-selected="' + pos + '"]').forEach(function (s) { s.textContent = val; });
      resolveVariant();
    });

    /* ---------------- Add-on ---------------- */
    var addonOn = false;
    function addonVariantId() {
      var el = root.querySelector('[data-addon-variant]');
      return el ? el.getAttribute('data-addon-variant') : null;
    }
    root.querySelectorAll('[data-addon-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addonOn = !addonOn;
        root.querySelectorAll('[data-addon-toggle]').forEach(function (b) { b.setAttribute('aria-pressed', addonOn ? 'true' : 'false'); });
      });
    });

    /* ---------------- Add to cart ---------------- */
    root.querySelectorAll('[data-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!current || !current.available || !window.Nurturi) return;
        var items = [{ id: current.id, quantity: 1 }];
        var addonId = addonVariantId();
        if (addonOn && addonId) items.push({ id: parseInt(addonId, 10), quantity: 1 });
        var label = btn.querySelector('[data-atc-text]');
        var original = label ? label.textContent : '';
        if (label) label.textContent = 'Adding…';
        btn.disabled = true;
        window.Nurturi.addToCart(items).then(function () {
          if (label) label.textContent = 'Added ✓';
          setTimeout(function () { if (label) label.textContent = original; btn.disabled = false; }, 1200);
        }).catch(function () { if (label) label.textContent = original; btn.disabled = false; });
      });
    });

    /* ---------------- Accordions (one open / group, animated) ---------------- */
    var DUR = 320, EASE = DUR + 'ms cubic-bezier(.4,0,.2,1)';
    // Batch the getComputedStyle reads (pass 1) apart from the style writes (pass 2) so the
    // 8 accordions (4 × both layouts) don't force a layout flush on every iteration.
    var accItems = [];
    root.querySelectorAll('details[data-accordion]').forEach(function (d) {
      var summary = d.querySelector('summary');
      var body = summary ? summary.nextElementSibling : null;
      if (!body) return;
      var cs = getComputedStyle(body);
      accItems.push({ d: d, summary: summary, body: body, padTop: cs.paddingTop, padBottom: cs.paddingBottom });
    });
    accItems.forEach(function (it) {
      var d = it.d, summary = it.summary, body = it.body, padTop = it.padTop, padBottom = it.padBottom;
      body.style.overflow = 'hidden';
      body.style.willChange = 'height, padding';
      if (!d.open) { body.style.height = '0px'; body.style.paddingTop = '0px'; body.style.paddingBottom = '0px'; }

      d._close = function () {
        if (!d.open || d._busy) return;
        d._busy = true;
        body.style.transition = 'none';
        body.style.height = body.scrollHeight + 'px';
        body.style.paddingTop = padTop; body.style.paddingBottom = padBottom;
        requestAnimationFrame(function () {
          body.style.transition = 'height ' + EASE + ', padding ' + EASE;
          body.style.height = '0px'; body.style.paddingTop = '0px'; body.style.paddingBottom = '0px';
        });
        setTimeout(function () { d.open = false; d._busy = false; }, DUR + 20);
      };
      d._open = function () {
        if (d.open || d._busy) return;
        d._busy = true; d.open = true;
        body.style.transition = 'none';
        body.style.height = 'auto'; body.style.paddingTop = padTop; body.style.paddingBottom = padBottom;
        var h = body.scrollHeight;
        body.style.height = '0px'; body.style.paddingTop = '0px'; body.style.paddingBottom = '0px';
        requestAnimationFrame(function () {
          body.style.transition = 'height ' + EASE + ', padding ' + EASE;
          body.style.height = h + 'px'; body.style.paddingTop = padTop; body.style.paddingBottom = padBottom;
        });
        setTimeout(function () { body.style.height = 'auto'; d._busy = false; }, DUR + 20);
      };

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (d._busy) return;
        if (d.open) { d._close(); }
        else {
          d.parentElement.querySelectorAll(':scope > details[data-accordion]').forEach(function (o) { if (o !== d && o.open) o._close(); });
          d._open();
        }
      });
    });

    /* -------- Buy-box star rating → open + scroll to the reviews dropdown -------- */
    function goToReviews(fromEl) {
      var scope = fromEl.closest('.pdp-desktop, .pdp-mobile') || root;
      var acc = scope.querySelector('[data-reviews-acc]');
      if (!acc) return;
      if (!acc.open && acc._open) {
        acc.parentElement.querySelectorAll(':scope > details[data-accordion]').forEach(function (o) { if (o !== acc && o.open && o._close) o._close(); });
        acc._open();
      }
      var header = document.querySelector('.section-header');
      var off = (header ? header.getBoundingClientRect().height : 0) + 14;
      window.scrollTo({ top: acc.getBoundingClientRect().top + window.pageYOffset - off, behavior: 'smooth' });
    }
    root.querySelectorAll('[data-reviews-link]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); goToReviews(el); });
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); goToReviews(el); } });
    });

    /* ---------------- Sticky ATC (mobile) ---------------- */
    /* Shown only through the middle of the PDP: after the buy box scrolls above the
       top, and hidden again once the static Add-to-Cart at the bottom is reached
       (stays hidden through the footer; reappears if scrolled back up above it). */
    var anchor = root.querySelector('[data-sticky-anchor]');
    var bar = root.querySelector('[data-sticky-bar]');
    var finalCta = document.querySelector('[data-btf-atc]'); // static CTA at the bottom of the PDP
    if (anchor && bar && 'IntersectionObserver' in window) {
      var pastBuyBox = false, atFinalCta = false;
      var applyStickyBar = function () {
        var show = pastBuyBox && !atFinalCta;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.inert = !show;
      };
      new IntersectionObserver(function (entries) {
        pastBuyBox = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        applyStickyBar();
      }, { threshold: 0 }).observe(anchor);
      if (finalCta) {
        new IntersectionObserver(function (entries) {
          // true once the static CTA reaches the bar's zone, and stays true below it
          atFinalCta = entries[0].isIntersecting || entries[0].boundingClientRect.top < 0;
          applyStickyBar();
        }, { threshold: 0, rootMargin: '0px 0px -64px 0px' }).observe(finalCta);
      }
    }

    /* -------- Okendo rating hydration (fallback when the SSR metafield summary is empty) -------- */
    (function () {
      var source = root.querySelector('[data-pdp-rating-source]');
      if (!source) return; // SSR already had live data, or Okendo is off
      var obs = null, poll = null, done = false;

      function finish() { done = true; if (obs) obs.disconnect(); if (poll) clearInterval(poll); }

      function hydrate() {
        if (done) return;
        var text = (source.textContent || '').replace(/\s+/g, ' ').trim();
        var aria = '';
        source.querySelectorAll('[aria-label]').forEach(function (el) { aria += ' ' + (el.getAttribute('aria-label') || ''); });
        var hay = (aria + ' ' + text).trim();
        if (!hay) return;

        var m = hay.match(/([0-5](?:\.\d+)?)\s*(?:out of|\/)\s*5/i);
        var avg = m ? parseFloat(m[1]) : NaN;
        var c = hay.match(/(\d[\d,]*)\s*(?:reviews?|ratings?)/i) || hay.match(/\((\d[\d,]*)\)/);
        var count = c ? parseInt(c[1].replace(/,/g, ''), 10) : NaN;

        if (isNaN(avg) || avg <= 0 || avg > 5) return;
        if (isNaN(count) || count <= 0) return;

        finish();
        var avgFmt = (Math.round(avg * 10) / 10).toFixed(1);
        root.querySelectorAll('[data-rating-val]').forEach(function (el) { el.textContent = avgFmt; });
        root.querySelectorAll('[data-rating-count]').forEach(function (el) { el.textContent = '(' + count + ')'; });
      }

      try {
        if ('MutationObserver' in window) {
          obs = new MutationObserver(hydrate);
          obs.observe(source, { childList: true, subtree: true, characterData: true });
        }
        poll = setInterval(hydrate, 600);
        setTimeout(finish, 12000);
        hydrate();
      } catch (e) {}
    })();

    /* -------- Reviews "Read more" clamp (Okendo's native truncation is unreliable in the dual-layout accordion) -------- */
    (function () {
      function clamp() {
        root.querySelectorAll('.oke-reviewContent-body').forEach(function (body) {
          if (body.dataset.ntClamp) return;
          if (!body.offsetParent) return;                       // hidden (other layout) → handle when visible
          body.dataset.ntClamp = '1';
          if (body.scrollHeight - body.clientHeight < 4) return; // fits → no toggle needed
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'nt-readmore';
          btn.textContent = 'Read more';
          body.insertAdjacentElement('afterend', btn);
          btn.addEventListener('click', function () {
            var open = body.classList.toggle('nt-open');
            btn.textContent = open ? 'Read less' : 'Read more';
          });
        });
      }
      try {
        if ('MutationObserver' in window) {
          var ct;                                             // debounce: Okendo fires many mutations while rendering — coalesce into one measure pass
          var ro = new MutationObserver(function () { clearTimeout(ct); ct = setTimeout(clamp, 120); });
          root.querySelectorAll('[data-oke-widget]').forEach(function (w) { ro.observe(w, { childList: true, subtree: true }); });
        }
        var rt;
        window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(clamp, 200); });
        clamp();
      } catch (e) {}
    })();

    /* -------- Reviewer badge "Verified Buyer" → "Verified" -------- */
    (function () {
      // Rewrites the text node rather than hiding it behind a CSS ::before, so screen readers
      // announce the label once. Not debounced: the swap needs to land on the same frame Okendo
      // renders the card, otherwise the old wording flashes.
      function relabel() {
        root.querySelectorAll('.oke-w-reviewer-verified').forEach(function (badge) {
          if (badge.dataset.ntLabel) return;
          Array.prototype.forEach.call(badge.childNodes, function (node) {
            if (node.nodeType === 3 && node.nodeValue.indexOf('Verified Buyer') !== -1) {
              node.nodeValue = node.nodeValue.replace('Verified Buyer', 'Verified');
              badge.dataset.ntLabel = '1';
            }
          });
        });
      }
      try {
        if ('MutationObserver' in window) {
          var mo = new MutationObserver(relabel);
          root.querySelectorAll('[data-oke-widget]').forEach(function (w) { mo.observe(w, { childList: true, subtree: true }); });
        }
        relabel();
      } catch (e) {}
    })();

    /* -------- AI summary "Read more" (5-line clamp; our own server-rendered markup, so re-check after fonts/resize) -------- */
    (function () {
      function setup() {
        root.querySelectorAll('.pdp-okendo-summary__ai-body').forEach(function (body) {
          if (body.dataset.ntClamp) return;
          if (!body.offsetParent) return;                        // hidden layout → handle when visible
          if (body.scrollHeight - body.clientHeight < 4) return; // fits → leave unmarked so a later pass can re-check
          body.dataset.ntClamp = '1';
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'nt-readmore';
          btn.textContent = 'Read more';
          body.insertAdjacentElement('afterend', btn);
          btn.addEventListener('click', function () {
            body.classList.add('nt-open');   // expand fully, then remove the link (no "Read less")
            btn.remove();
          });
        });
      }
      try {
        var rt;
        window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(setup, 200); });
        setup();
        setTimeout(setup, 500);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(setup);
      } catch (e) {}
    })();

    // set initial variant state
    if (current) applyVariant(current);

    // Deferred to idle so warming the colourway photos never competes with first paint.
    (window.requestIdleCallback || function (fn) { return setTimeout(fn, 1500); })(warmVariantHeroes);
  }

  function boot() { document.querySelectorAll('[data-product-section]').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-product-section]');
    if (sec) { sec._ntInit = false; initSection(sec); }
  });
})();

/* PDP below-the-fold (pdp-btf): M16 close CTA proxies the buy-box Add-to-Cart and mirrors its live price/label. */
(function () {
  var wrap = document.querySelector('[data-btf]');
  if (!wrap) return;
  var proxy = wrap.querySelector('[data-btf-atc]');
  var real = document.querySelector('[data-product-section] [data-atc]');
  if (!proxy || !real) return;
  proxy.addEventListener('click', function () {
    real.click();
    (window.dataLayer = window.dataLayer || []).push({ event: 'atc_click', placement: 'close' });
  });
  [
    [document.querySelector('[data-product-section] [data-price-now]'), wrap.querySelector('[data-btf-now]')],
    [document.querySelector('[data-product-section] [data-price-was]'), wrap.querySelector('[data-btf-was]')],
    [real.querySelector('[data-atc-text]'), wrap.querySelector('[data-btf-atc-text]')]
  ].forEach(function (p) {
    var src = p[0], dst = p[1];
    if (!src || !dst) return;
    var sync = function () {
      dst.textContent = src.textContent;
      if (src.hasAttribute && src.hasAttribute('hidden')) { dst.setAttribute('hidden', ''); } else { dst.removeAttribute('hidden'); }
    };
    sync();
    if ('MutationObserver' in window) { new MutationObserver(sync).observe(src, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden'] }); }
  });
})();

/* ===== Mobile PDP sticky chrome =============================================
   Announcement + nav are fixed top-chrome that hide/reveal on scroll direction.
   Announcement hides once the carousel top reaches it; nav hides once the sticky
   Add-to-Cart shows. On scroll-up the announcement reveals first, the nav follows
   (fade + slide, staggered in CSS). Passive + rAF-throttled; mobile PDP only. */
(function () {
  var mq = window.matchMedia('(max-width:768px)');
  var html = document.documentElement;
  var ann = document.querySelector('.section-announcement');
  var nav = document.querySelector('.section-header');
  var gallery = document.querySelector('.pdp-only-mobile [data-gallery]');
  var anchor = document.querySelector('[data-sticky-anchor]'); // mobile buy card (drives the sticky ATC)
  if (!nav || !gallery) return; // only wire up on a PDP with the expected structure

  var active = false, ticking = false, lastY = 0, dir = 'up';

  function measure() {
    var annH = ann ? ann.offsetHeight : 0;
    html.style.setProperty('--nt-ann-h', annH + 'px');
    html.style.setProperty('--nt-chrome-h', (annH + nav.offsetHeight) + 'px');
  }

  function update() {
    ticking = false;
    var y = window.pageYOffset || 0;
    if (y > lastY + 3) dir = 'down'; else if (y < lastY - 3) dir = 'up';
    lastY = y;
    var annH = ann ? ann.offsetHeight : 0;
    var annReady = gallery.getBoundingClientRect().top <= annH + 1;  // carousel top reached the bar
    var navReady = !!(anchor && anchor.getBoundingClientRect().bottom <= 0);  // buy card scrolled past → sticky ATC shows
    html.classList.toggle('nt-ann-hidden', annReady && dir === 'down');
    html.classList.toggle('nt-nav-hidden', navReady && dir === 'down');
  }

  function onScroll() { if (active && !ticking) { ticking = true; requestAnimationFrame(update); } }

  function activate() {
    if (active) return;
    active = true;
    measure();
    html.classList.add('nt-pdp-sticky');
    lastY = window.pageYOffset || 0;
    update();
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (active) html.classList.add('nt-chrome-anim'); }); });
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  function deactivate() {
    if (!active) return;
    active = false;
    window.removeEventListener('scroll', onScroll);
    html.classList.remove('nt-pdp-sticky', 'nt-chrome-anim', 'nt-ann-hidden', 'nt-nav-hidden');
  }
  function sync() { if (mq.matches) activate(); else deactivate(); }

  sync();
  if (mq.addEventListener) mq.addEventListener('change', sync); else mq.addListener(sync);
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { if (active) measure(); }, 150); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (active) measure(); });
})();

/* ============================================================================
   Sticky add-to-cart variant dropdowns
   ---------------------------------------------------------------------------
   Deliberately thin. The menu items carry data-option-value / data-value, and
   pdp.js's existing delegated handler on the product section already reads
   those to set the variant, sync aria-pressed across every picker instance and
   update [data-option-selected] text. So this owns only two things the shared
   handler can't do: open/close the menu, and repaint the colour dot (a
   background, not text, so nothing generic updates it).
   The dot listener is bound to ANY [data-option-value] click, not just menu
   items, so picking a colour from the buy-box swatches repaints the sticky dot
   too — the two pickers must never disagree.
   ========================================================================== */
(function () {
  var openWrap = null;

  function close(wrap) {
    if (!wrap) return;
    wrap.removeAttribute('data-open');
    var menu = wrap.querySelector('[data-satc-menu]');
    if (menu) menu.hidden = true;
    var toggle = wrap.querySelector('[data-satc-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (openWrap === wrap) openWrap = null;
  }

  function open(wrap) {
    var menu = wrap.querySelector('[data-satc-menu]');
    if (menu) menu.hidden = false;
    wrap.setAttribute('data-open', '');
    var toggle = wrap.querySelector('[data-satc-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    openWrap = wrap;
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-satc-toggle]');
    if (toggle) {
      var wrap = toggle.closest('[data-satc-opt]');
      var wasOpen = wrap.hasAttribute('data-open');
      if (openWrap && openWrap !== wrap) close(openWrap);
      if (wasOpen) close(wrap); else open(wrap);
      return;
    }

    var opt = e.target.closest('[data-option-value]');
    if (opt) {
      // repaint the sticky colour dot for this option from the matching menu item
      var pos = opt.getAttribute('data-option-value');
      var val = opt.getAttribute('data-value');
      var hex = null;
      document.querySelectorAll('[data-satc-item][data-option-value="' + pos + '"]').forEach(function (item) {
        if (item.getAttribute('data-value') === val) hex = item.getAttribute('data-swatch-hex');
      });
      if (hex) {
        document.querySelectorAll('[data-satc-dot="' + pos + '"]').forEach(function (dot) {
          dot.style.background = hex;
        });
      }
      if (opt.hasAttribute('data-satc-item')) close(opt.closest('[data-satc-opt]'));
      return;
    }

    if (openWrap) close(openWrap);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openWrap) close(openWrap);
  });
})();
